// TODO rename containing folder, these components are grid/alignment elements, not table elements
import Column from "./Column";
import Row from "./Row";

export { Column, Row };
export default { Column, Row };
